export enum FieldType{
    ComboboxField = "ComboboxField",
    TextField = "TextField",
}